const menuItems = [
    {
        id: 'healthcare',
        label: 'Healthcare',
        submenu: [
            { id: '1', label: 'Healthcare' },
            { id: '2', label: 'Insurance' },
            { id: '3', label: 'Pet Health' },
            { id: '4', label: 'Reward' },
            { id: '5', label: 'Transportation' },
            { id: '6', label: 'Others' },
        ],
    },
    {
        id: '119',
        label: 'Music',
        submenu: [
            { id: '76', label: 'Country' },
            { id: '77', label: 'Bluegrass' },
            { id: '109', label: 'R & B' },
            { id: '79', label: 'Rock' },
            { id: '110', label: 'Pop' },
            { id: '111', label: 'Gospel' },
            { id: '112', label: 'Hip-Hop' },
            { id: '113', label: 'Jazz' },
            { id: '114', label: 'Classical' },
        ],
    },
    {
        id: '120',
        label: 'Cinema',
        submenu: [
            { id: '105', label: 'Movies' },
            { id: '106', label: 'Podcasts' },
            { id: '107', label: 'Shows' },
            { id: '108', label: 'Videos' },
        ],
    },
];

export default menuItems;
